import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/error.tsx");
